import Dialog	from "dialog";
import template	from "../html/aboutdialog.html";
import css		from "../css/aboutdialog.css";

class AboutDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-about", AboutDialog);
  }
  constructor() {
    super();

    this.init();
  }
  async init() {
    this.labelLinuxVersion.value = await server.rcall("RM_getLinuxVersion");
    this.labelV8Version.value = "FullJS v8 version " + await server.rcall("RM_getV8Version");
    this.labelClientVersion.value = window.navigator.userAgent;
	this.show();    
  }
  buttonClose_click() {
    this.close();
  }
}

AboutDialog.constructor();

export default AboutDialog;